import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/EditFormModal";
import QuestionForm from "./QuestionForm";
const EditQuestion = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Edit_Question_Modal, initialValues, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <div>
      <FormModal
        modalTitle="Edit Question"
     
        submitButtonText="Update"
        cancelButtonText="Cancel"
        editApiRequest="EditRecord"
        apiLoader="StartSpinner"
        editApiMethod="PUT"
        editApiName="editTriggerQuestion"
        ModalName="Edit_Question_Modal"
        confirmLoading={Loader}
        ModalType="Hide_Modal"
        visible={Edit_Question_Modal ? Edit_Question_Modal : false}
        initialValues={initialValues}
        width={550}
        form={form}
        recordName="questionList"
      >
        <QuestionForm />
      </FormModal>
    </div>
  );
};

export default EditQuestion;
